






















































import { Component, Vue } from "vue-property-decorator";
import Card from "./Card.vue";
import { namespace } from "vuex-class";

const globalStore = namespace("global");

@Component({ components: { Card } })
export default class LoginForm extends Vue {
  @globalStore.Getter applicationName!: string;

  emailAddress = "";
  send = false;
  success = false;
  loading = false;

  reset(): void {
    this.send = false;
    this.success = false;
  }

  postRequestMagicLink(emailAddress: string): unknown {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require("modules/base/api").postRequestMagicLink(emailAddress);
  }

  async login(): Promise<void> {
    this.loading = true;
    try {
      await this.postRequestMagicLink(this.emailAddress);
      this.success = true;
    } catch (e) {
      this.success = false;
    }
    this.send = true;
    this.loading = false;
  }
}
